// Mock data for Lalit Interior website

export const heroData = {
  tagline: "We Are Delivering Turnkey Excellency",
  quote: "Where Vision Meets Precision – Crafting Spaces That Inspire",
  ctaText: "Discover Our Services",
  heroImage: "/bright-hero.jpg"
};

export const aboutData = {
  title: "About Us",
  description: `Lalit Interior is a trusted name in turnkey interior execution, delivering high-quality projects with precision, commitment, and professionalism. With over 8 years of proven experience, we specialize exclusively in interior execution, including MEP works, fire-fighting installations, and interior-related civil works (excluding structural construction).

As a full-service company, we provide end-to-end Project Management Consultancy (PMC) services. From conceptualization to final handover, Lalit Interior manages every aspect of your project with meticulous attention to detail, ensuring timely delivery without compromising on quality. We utilize a third-party Project Management Application that allows our clients to monitor real-time progress, work schedules, site reports, milestones, and photographic updates.

Operating across PAN-India locations, we have built a reputation for executing diverse projects—from intimate residential spaces to expansive commercial complexes and luxury hospitality venues. Our focus on transparency, reliability, and uncompromising quality has helped us build long-term relationships with our clients.

At Lalit Interior, we are driven by our vision to be a leading force in the construction and interior industry by delivering innovative, sustainable, and precision-driven turnkey solutions. Our mission is to deliver excellence in every phase by combining technical expertise, innovative practices, and the highest standards of safety and sustainability. We believe in building a better tomorrow, one project at a time.`,
  stats: [
    { number: "8+", label: "Years Experience" },
    { number: "2 Lakh+", label: "Sq.ft. Work Done" },
    { number: "150+", label: "Projects Completed" },
    { number: "300+", label: "Manpower" }
  ],
  imageUrl: "/about-image.jpg"
};

export const servicesData = [
  {
    id: 1,
    title: "Interior Fit-out",
    description: "Complete turnkey fit-out solutions from design to handover, including modular furnishing, carpentry work, false ceiling, and premium painting.",
    features: ["Turnkey Fit-out (Design to Handover)", "Modular & Soft Furnishing", "Carpentry Work", "False Ceiling & Painting"]
  },
  {
    id: 2,
    title: "MEP & HVAC",
    description: "Comprehensive MEP services including electrical systems, plumbing, HVAC installations, and smart home automation solutions.",
    features: ["Electrical Work", "Plumbing Work", "HVAC Systems", "Smart Home & Automation"]
  },
  {
    id: 3,
    title: "Fire Fighting & Safety",
    description: "Complete fire-fighting and suppression systems designed and installed to meet all safety regulations and standards.",
    features: ["Fire Detection Systems", "Sprinkler Systems", "Fire Suppression", "Safety Compliance"]
  },
  {
    id: 4,
    title: "PMC Service",
    description: "End-to-end Project Management Consultancy with real-time tracking, quality control, cost management, and timely execution.",
    features: ["Project Planning & Coordination", "Quality Control & Site Supervision", "Cost Management", "Real-time Progress Tracking"]
  }
];

export const portfolioData = [
  // Hospitality Projects
  {
    id: 1,
    title: "Hotel KK Palace - Complete Turnkey",
    category: "Hospitality",
    location: "Datia, Madhya Pradesh",
    imageUrl: "https://images.unsplash.com/photo-1597106525363-7916ebf5b083",
    description: "Comprehensive turnkey project including basic civil work, complete interior fit-out, MEP systems, fire-fighting installation, and premium furnishing. A landmark hospitality project.",
    scope: "Turnkey - Civil, Interior, MEP, Furnishing",
    client: "Hotel KK Palace"
  },
  {
    id: 2,
    title: "Hotel Vinayam - Luxury Hospitality",
    category: "Hospitality",
    location: "Damoh, Madhya Pradesh",
    imageUrl: "https://images.unsplash.com/photo-1759038085935-b2f14c2c04a7",
    description: "Luxury hotel featuring basic civil work, complete interior design and execution, MEP & HVAC systems, fire-fighting, and high-end furnishing for a premium guest experience.",
    scope: "Turnkey - Civil, Interior, MEP, Furnishing",
    client: "Hotel Vinayam"
  },
  {
    id: 3,
    title: "Hotel Rahul - Commercial Hotel",
    category: "Hospitality",
    location: "Russel Chowk, Jabalpur, MP",
    imageUrl: "https://images.unsplash.com/photo-1566073771259-6a8506099945",
    description: "Complete hotel interior execution with modern amenities, comfortable guest rooms, and elegant common areas.",
    scope: "Commercial Hotel Interior",
    client: "Hotel Rahul"
  },
  {
    id: 4,
    title: "The Leela Palace - Renovation Work",
    category: "Hospitality",
    location: "Adyar, Chennai, Tamil Nadu",
    imageUrl: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b",
    description: "Premium renovation work for The Leela Palace, maintaining luxury standards and heritage aesthetics.",
    scope: "Renovation & Restoration",
    client: "The Leela Palace"
  },
  {
    id: 5,
    title: "TBH Italia Restaurant",
    category: "Hospitality",
    location: "Jabalpur, MP",
    imageUrl: "https://images.unsplash.com/photo-1514933651103-005eec06c04b",
    description: "Authentic Italian restaurant interior with elegant ambiance, premium finishes, and European design elements.",
    scope: "Restaurant Interior",
    client: "TBH Italia"
  },
  {
    id: 6,
    title: "Red Box - Indo Chinese Restaurant",
    category: "Hospitality",
    location: "8 Outlets, Multiple Locations",
    imageUrl: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4",
    description: "Complete turnkey execution for 8 Red Box outlets featuring contemporary Indo-Chinese design and consistent branding.",
    scope: "8 Restaurant Outlets",
    client: "Red Box"
  },
  {
    id: 7,
    title: "Chaayos Tea Cafe - DLF Chennai",
    category: "Hospitality",
    location: "DLF Cybercity, Manapakkam, Chennai, Tamil Nadu",
    imageUrl: "https://images.unsplash.com/photo-1567696911980-2eed69a46042",
    description: "Modern tea cafe with vibrant interiors and cozy seating at The Hub, DLF Cybercity Chennai.",
    scope: "Cafe Interior",
    client: "Chaayos"
  },
  {
    id: 8,
    title: "Chaayos Tea Cafe - Phoenix Mall",
    category: "Hospitality",
    location: "Phoenix Mall, Chennai, Tamil Nadu",
    imageUrl: "https://images.unsplash.com/photo-1554118811-1e0d58224f24",
    description: "Trendy tea cafe interior at Phoenix Mall with contemporary design and welcoming atmosphere.",
    scope: "Cafe Interior",
    client: "Chaayos"
  },
  {
    id: 9,
    title: "Eatclub - Multi-Brand Dining Outlet",
    category: "Hospitality",
    location: "DLF Cybercity, Manapakkam, Chennai, Tamil Nadu",
    imageUrl: "https://images.unsplash.com/photo-1559339352-11d035aa65de",
    description: "Club of 8 dining brands including Box 8, Mojo Pizza - complete execution at The Hub, DLF Cybercity.",
    scope: "Multi-Brand Food Court",
    client: "Eatclub (Box 8, Mojo Pizza)"
  },
  
  // Commercial Projects
  {
    id: 10,
    title: "Serendipity Café - Premium Fine Dining",
    category: "Commercial",
    location: "Jabalpur, Madhya Pradesh",
    imageUrl: "https://images.unsplash.com/photo-1766325629329-c98e07e26e25",
    description: "Complete turnkey interior fit-out for a premium fine dining restaurant with contemporary design, elegant ambiance, warm lighting, and sophisticated furniture.",
    scope: "Full Interior Fit-out",
    client: "Serendipity Cafe"
  },
  {
    id: 11,
    title: "The Forge Gym - Mega Fitness Center",
    category: "Commercial",
    location: "Jabalpur Stadium, Jabalpur, MP",
    imageUrl: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48",
    description: "Massive 22,000 sq.ft state-of-the-art gym development with modern equipment, training zones, and premium finishes.",
    scope: "22,000 Sq.Ft Gym Development",
    client: "The Forge Gym"
  },
  {
    id: 12,
    title: "DLF Thrive Gym",
    category: "Commercial",
    location: "DLF Cybercity, Manapakkam, Chennai, Tamil Nadu",
    imageUrl: "https://images.unsplash.com/photo-1571902943202-507ec2618e8f",
    description: "Premium commercial gym project at The Hub featuring cutting-edge fitness facilities and modern design.",
    scope: "Commercial Gym",
    client: "DLF Thrive Gym"
  },
  {
    id: 13,
    title: "Mr. Arman Salon and Spa",
    category: "Commercial",
    location: "Jabalpur, MP",
    imageUrl: "https://images.unsplash.com/photo-1560066984-138dadb4c035",
    description: "Luxury salon and spa interior with elegant styling stations, relaxation zones, and premium ambiance.",
    scope: "Salon & Spa Interior",
    client: "Mr. Arman Salon"
  },
  {
    id: 14,
    title: "Mipalloy Conference Room - Corporate",
    category: "Commercial",
    location: "SIPCOT, Sriperumbudur, Chennai",
    imageUrl: "https://images.unsplash.com/photo-1657978837950-03646a7c7b9e",
    description: "Professional turnkey contract for modern conference room with state-of-the-art facilities, acoustic treatment, and premium finishes.",
    scope: "Turnkey Contract",
    client: "Mipalloy"
  },
  {
    id: 15,
    title: "Niiyam Wise Law Firm Office",
    category: "Commercial",
    location: "Jabalpur, Madhya Pradesh",
    imageUrl: "https://images.unsplash.com/photo-1497366754035-f200968a6e72",
    description: "Sophisticated advocate office interior with elegant design, professional ambiance, and functional workspace layout.",
    scope: "Complete Interior",
    client: "Niiyam Wise Law Firm"
  },
  
  // Residential Projects
  {
    id: 16,
    title: "Mr. Anirudh Dubey Bungalow",
    category: "Residential",
    location: "Jabalpur, MP",
    imageUrl: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9",
    description: "Luxurious residential bungalow with contemporary design, spacious interiors, and premium finishes.",
    scope: "Residential Bungalow",
    client: "Mr. Anirudh Dubey"
  },
  {
    id: 17,
    title: "Mr. Geet Sachdeva Bungalow",
    category: "Residential",
    location: "Jabalpur, MP",
    imageUrl: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
    description: "Modern luxury bungalow featuring elegant living spaces, custom furniture, and sophisticated design elements.",
    scope: "Residential Bungalow",
    client: "Mr. Geet Sachdeva"
  },
  {
    id: 18,
    title: "Dr. Harsha Bungalow",
    category: "Residential",
    location: "Jabalpur, MP",
    imageUrl: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c",
    description: "Elegant residential bungalow with thoughtful design, functional spaces, and high-quality execution.",
    scope: "Residential Bungalow",
    client: "Dr. Harsha"
  },
  {
    id: 19,
    title: "Mr. Anirudh Tiwari Bungalow",
    category: "Residential",
    location: "Jabalpur, MP",
    imageUrl: "https://images.unsplash.com/photo-1600607687644-c7171b42498b",
    description: "Contemporary bungalow design with modern amenities, stylish interiors, and premium craftsmanship.",
    scope: "Residential Bungalow",
    client: "Mr. Anirudh Tiwari"
  },
  {
    id: 20,
    title: "Mr. Madhusudan - Heritage Bungalow",
    category: "Residential",
    location: "Datia, MP",
    imageUrl: "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde",
    description: "Heritage bungalow restoration and interior work preserving historical charm with modern functionality.",
    scope: "Heritage Restoration",
    client: "Mr. Madhusudan"
  },
  {
    id: 21,
    title: "Mr. Prakash Aswani Residence",
    category: "Residential",
    location: "Jabalpur, Madhya Pradesh",
    imageUrl: "https://images.unsplash.com/photo-1565031491910-e57fac031c41",
    description: "Stunning residential turnkey project with contemporary design, premium finishes, custom furniture, and complete MEP integration.",
    scope: "Turnkey Fit-out",
    client: "Mr. Prakash Aswani"
  },
  {
    id: 22,
    title: "Mr. Abhishek Urmaliya Residence",
    category: "Residential",
    location: "Jabalpur, Madhya Pradesh",
    imageUrl: "https://images.unsplash.com/photo-1601002257790-ebe0966a85ae",
    description: "3BHK modern home with meticulous planning, superior craftsmanship, and thoughtfully designed living spaces.",
    scope: "Turnkey Execution",
    client: "Mr. Abhishek Urmaliya"
  },
  {
    id: 23,
    title: "Mr. Senthil Kumar - 4BHK House",
    category: "Residential",
    location: "Chennai, Tamil Nadu",
    imageUrl: "https://images.unsplash.com/photo-1519868343531-805e97cbda3e",
    description: "Exceptional 4BHK residence with outstanding expertise, functional design, and magnificent interiors.",
    scope: "Turnkey Solution",
    client: "Mr. Senthil Kumar"
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Vinay Asati",
    position: "Owner",
    company: "Hotel Vinayam",
    location: "Damoh, Madhya Pradesh",
    quote: "Lalit Interior transformed our hotel completely. The attention to detail and flawless execution exceeded our expectations. Highly recommended for hospitality projects!",
    rating: 5
  },
  {
    id: 2,
    name: "Geet Sachdeva",
    position: "Homeowner",
    location: "Luxury Villa",
    quote: "Our dream villa became a reality thanks to Lalit Interior. Their team's professionalism and creative approach made the entire process smooth and enjoyable.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Prakash Aswani",
    position: "Homeowner",
    location: "5000 sq.ft. Residence, Jabalpur",
    quote: "Lalit Interior transformed my vision into an absolutely stunning 5000 sq.ft. home that exceeds every expectation. Their amazing craftsmanship, attention to detail, and unwavering commitment turned our dream house into a beautiful reality. From the initial design to the final touches, they earned my complete trust through professionalism and excellence. I wholeheartedly recommend them for any interior project!",
    rating: 5
  },
  {
    id: 4,
    name: "Mr. Senthil Kumar",
    position: "Homeowner & Restaurant Owner",
    location: "Chennai, Tamil Nadu",
    quote: "Lalit Interior delivered exceptional turnkey solutions for my 4BHK house and three restaurants in Chennai. From concept to completion, their team handled everything with outstanding expertise and precision, creating spaces that are both functional and magnificent. The excellent quality of their work has made all my properties stand out. I trusted them fully, and they exceeded every expectation—highly recommended!",
    rating: 5
  },
  {
    id: 5,
    name: "Mr. Sarthak",
    position: "Owner",
    company: "Serendipity Cafe and Restaurant",
    location: "Jabalpur, Madhya Pradesh",
    quote: "Lalit Interior brought my vision for Serendipity Cafe and Restaurant—a premium fine dining destination—to life through their flawless turnkey execution. Their excellent design, craftsmanship, and attention to every detail created an elegant, inviting space that draws crowds nightly. I trusted them completely, and the results are truly outstanding. A top recommendation for restaurant projects!",
    rating: 5
  },
  {
    id: 6,
    name: "Mr. Abhishek Urmaliya",
    position: "Homeowner",
    location: "3BHK Residence, Jabalpur",
    quote: "Lalit Interior exceeded all expectations with the turnkey execution of my 3BHK home. Their meticulous planning, superior craftsmanship, and dedication to quality transformed my house into a modern, comfortable living space. Every detail was thoughtfully designed and flawlessly executed. The team's professionalism and timely delivery made the entire experience hassle-free. Highly recommended for residential projects!",
    rating: 5
  },
  {
    id: 7,
    name: "Ms. Sakshi Aswani",
    position: "Advocate",
    company: "Niiyam Wise Law Firm",
    location: "Jabalpur, Madhya Pradesh",
    quote: "Lalit Interior designed and executed a sophisticated, professional office space for Niiyam Wise that perfectly reflects our firm's values. The turnkey solution included elegant interiors, functional layouts, and premium finishes that impress clients from the moment they enter. Their attention to detail and commitment to excellence made this project seamless. I highly recommend them for commercial and office projects!",
    rating: 5
  }
];

export const contactData = {
  title: "Start Your Project Today",
  subtitle: "Let's transform your space into something extraordinary",
  address: "Lalit Interior, 106, Shatabdipuram Phase-1, Opposite to Kesharwani College, New Adarsh Colony, Vijay Nagar, Jabalpur, Madhya Pradesh 482002",
  phone: "+91 7703046702",
  email: "hr@lalitinterior.in",
  email2: "pawan@lalitinterior.in",
  whatsapp: "+917703046702",
  website: "www.lalitinterior.in",
  instagram: "https://www.instagram.com/lalitinterior/",
  linkedin: "https://www.linkedin.com/company/lalit-interior/",
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3666.3214!2d79.97634!3d23.20156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3981ae8d5555555%3A0x5555555555555555!2sVijay%20Nagar%2C%20Jabalpur%2C%20Madhya%20Pradesh%20482002!5e0!3m2!1sen!2sin!4v1234567890"
};

// Client Brands/Logos
export const clientsData = [
  {
    id: 1,
    name: "Hotel KK Palace",
    category: "Hospitality",
    location: "Datia, MP"
  },
  {
    id: 2,
    name: "Hotel Vinayam",
    category: "Hospitality",
    location: "Damoh, MP"
  },
  {
    id: 3,
    name: "Hotel Rahul",
    category: "Hospitality",
    location: "Jabalpur, MP"
  },
  {
    id: 4,
    name: "The Leela Palace",
    category: "Hospitality",
    location: "Chennai"
  },
  {
    id: 5,
    name: "TBH Italia",
    category: "Restaurant",
    location: "Jabalpur, MP"
  },
  {
    id: 6,
    name: "Red Box",
    category: "Restaurant Chain",
    location: "8 Outlets"
  },
  {
    id: 7,
    name: "Chaayos",
    category: "Cafe Chain",
    location: "Chennai"
  },
  {
    id: 8,
    name: "Eatclub",
    category: "Food Court",
    location: "Chennai"
  },
  {
    id: 9,
    name: "Serendipity Cafe",
    category: "Fine Dining",
    location: "Jabalpur, MP"
  },
  {
    id: 10,
    name: "The Forge Gym",
    category: "Fitness",
    location: "Jabalpur, MP"
  },
  {
    id: 11,
    name: "DLF Thrive Gym",
    category: "Fitness",
    location: "Chennai"
  },
  {
    id: 12,
    name: "Mr. Arman Salon",
    category: "Salon & Spa",
    location: "Jabalpur, MP"
  },
  {
    id: 13,
    name: "Mipalloy",
    category: "Corporate",
    location: "Chennai"
  },
  {
    id: 14,
    name: "Niiyam Wise",
    category: "Law Firm",
    location: "Jabalpur, MP"
  }
];
